import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '_lib/theme';

type Props = {
  size?: number;
  color?: string;
};

const useStyles = createUseStyles((theme: Theme) => ({
  spinner: ({ size = 25, color = theme.colors.primary }: Props) => ({
    height: size,
    width: size,
    borderRadius: '50%',
    border: `2px solid ${color}`,
    borderLeft: '2px solid rgba(0,0,0,0)',
    animation: '$spin 0.6s infinite linear',
  }),
  '@keyframes spin': {
    from: { transform: 'rotate(0)' },
    to: { transform: 'rotate(360deg)' },
  },
}));

const Spinner = (props: Props) => {
  const classes = useStyles(props);
  return <div className={classes.spinner} />;
};

export default Spinner;
